import {Pagination} from "@allxsmith/bestax-bulma";


export default function PaginationWrapper({page, setPage, dataCount}){


    const getLinks = () => {
        let links = [];
        for(let i=1;i<=dataCount;i++){
            links.push(
                <Pagination.Link
                    key={i}
                    active={page  === i}
                    onClick={()  => setPage(i)}
                >
                    {i}
                </Pagination.Link>
            )
        }
        return links
    }

    return (
        <Pagination>
            <Pagination.List>
                {getLinks()}
            </Pagination.List>
        </Pagination>
    )

}